
import RootLayout from './layout/rootLayout.vue'
import ApplicantListRoute from './applicantList/route'
import CandidateRoute from './candidate/route'
import ExtensionRoute from './extensionPage/route'
import CompanyAdminRoute from './companyAdmin/route'
import ClientAdminRoute from './clientAdmin/route'
import JobListRoute from './jobList/route'
import TalentPoolRoute from './talentPool/route'
import CRMRoute from './crm/route'
import JobApplicantListRoute from './jobApplicantList/route'
import ReferralRoute from './referral/route'
import InterviewManagement from './interviewManagement/route'
import Potential from './potential/route'
import HrDashboardRoute from './hrDashboard/route'
import JobRoute from './job/route'
import rpaRoute from './rpa/route'
import chatbotManagementRoute from './chatbotManagement/route'
import apSchedulerRoute from './apScheduler/route'
import notificationRoute from './notification/route'
import AITalentRecommendedRoute from './aiTalentRecommendedList/route'
import companyProfileRoute from './companyProfile/route'
import companyCultureRoute from './companyCulture/route'
import resetPasswordRoute from './resetPassword/route'

const routes = [
  ApplicantListRoute,
  ...CandidateRoute,
  ExtensionRoute,
  CompanyAdminRoute,
  ClientAdminRoute,
  JobListRoute,
  TalentPoolRoute,
  CRMRoute,
  ReferralRoute,
  InterviewManagement,
  JobApplicantListRoute,
  Potential,
  HrDashboardRoute,
  JobRoute,
  apSchedulerRoute,
  notificationRoute,
  chatbotManagementRoute,
  rpaRoute,
  AITalentRecommendedRoute,
  companyProfileRoute,
  companyCultureRoute,
  resetPasswordRoute
]

export default {
  name: 'newAdminRootLayout',
  path: '',
  component: RootLayout,
  meta: {
    isRootLayout: true
  },
  children: routes
}

export const allLayoutRoutes = routes
